// PostCardCategory.js
'use strict';
import { connect } from 'react-redux';
import LRU from 'lru-cache';

import PostCardCategory from '../component/PostCardCategory.jsx';

import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import { getFeedNameType } from '../resource/feedUtils.js';

const cache = new LRU({ max: 128 });
const getSelectPath = ({ category } = {}) => {
  const key = `${category}`;
  let result = cache.get(key);
  if (!result) {
    result = ['home', getFeedNameType({ feedName: category }), category];
    cache.set(key, result);
  }
  return result;
};

const mapStateToProps = (state, { category }) => {
  const listSelectPath = getSelectPath({ category });
  const nextPage = getListData(state, listSelectPath, 'nextPage');
  return {
    nextPage,
    isNextPageFetching: !!getNetworkingData(
      state,
      [...listSelectPath, nextPage],
      'isFetching'
    ),
    isFirstPageFetched: !!getNetworkingData(
      state,
      [...listSelectPath, 1],
      'isFetched'
    ),
    messageIds: getListData(state, listSelectPath, 'itemIds'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostCardCategory);
